export const comparisonLegend = [
  { label: "Strong Fit", description: "looks clearly stronger for the priorities you gave the most weight", toneClass: "bg-[#22C55E]" },
  { label: "Moderate Fit", description: "can work, but the tradeoffs need a closer look", toneClass: "bg-[#F59E0B]" },
  { label: "Situational Fit", description: "may work only if a specific constraint or preference matters more than the rest", toneClass: "bg-[#7C3AED]" },
];

export const comparisonMetrics = [
  {
    id: "lifestyle_fit",
    label: "Lifestyle Fit",
    description: "Helps you compare the day-to-day living experience across this shortlist, based on the priorities you shared in your assessment.",
  },
  {
    id: "healthcare_quality",
    label: "Healthcare Quality",
    description: "Helps you compare medical care, access, and system reliability across the countries still in play.",
  },
  {
    id: "residency_path",
    label: "Residency Path",
    description: "Helps you compare how realistic the move still looks once residency pathways and constraints are included.",
  },
  {
    id: "cost_of_living_fit",
    label: "Cost of Living Fit",
    description: "Helps you compare where your budget holds up best across the finalists in this set.",
  },
  {
    id: "ease_of_relocation",
    label: "Ease of Relocation",
    description: "Helps you compare which country looks easier to carry from idea to real move, given your priorities and constraints.",
  },
];